export function getSquadNetHP(squad) {
    return squad.reduce((acc, item) => acc + item.hp, 0);
}
